"use client";
import { j as l } from "./index.es73.js";
import { useState as p, useRef as x, useMemo as n } from "react";
import { makeUniqueId as m, composeClassNames as h } from "./index.es139.js";
import { useOutsideRefClickCallback as f } from "./index.es468.js";
const v = ({
  label: b,
  buttonText: d,
  children: s,
  buttonId: t,
  listboxId: a,
  ...u
}) => {
  const [e, i] = p(!1), c = x(null), o = n(() => m(), []), r = n(() => m(), []);
  return f(
    c,
    () => i(!1)
  ), /* @__PURE__ */ l.jsxs("div", { className: "bl-multiselect__wrapper", children: [
    /* @__PURE__ */ l.jsx(
      "label",
      {
        className: "bl-size-6 bl-display-block",
        htmlFor: t || r,
        children: b
      }
    ),
    /* @__PURE__ */ l.jsxs(
      "div",
      {
        className: h(
          "bl-multiselect",
          e && "bl-multiselect--is-open",
          "bl-m-t-1"
        ),
        ref: c,
        children: [
          /* @__PURE__ */ l.jsxs(
            "button",
            {
              ...u,
              id: t || r,
              type: "button",
              onClick: () => i(!e),
              className: "bl-multiselect__button bl-input",
              "aria-expanded": e,
              "aria-controls": a || o,
              "aria-haspopup": "listbox",
              children: [
                /* @__PURE__ */ l.jsx("span", { children: d }),
                /* @__PURE__ */ l.jsx("i", { className: "bl-multiselect__icon bl-icon--chevron-down bl-icon--small" })
              ]
            }
          ),
          s && /* @__PURE__ */ l.jsx("div", { className: "bl-multiselect__children-wrapper", children: /* @__PURE__ */ l.jsx(
            "div",
            {
              id: a || o,
              role: "listbox",
              "aria-multiselectable": "true",
              className: "bl-multiselect__children",
              children: s
            }
          ) })
        ]
      }
    )
  ] });
};
export {
  v as default
};
//# sourceMappingURL=index.es421.js.map
